import { formatName } from "../../../../utils/format-name.ts";
import { useUser } from "../../../../lib/rbac/useUser.ts";

export interface OffboardingEmployeeDisplay {
    name: string;
    empType: string;
    designation: string;
    employeeId: string;
    email: string;
    department: string;
    manager: string;
    photoPath?: string;
}

export function useOffboardingEmployeeDisplay(): OffboardingEmployeeDisplay {
    const user = useUser();

    return {
        name: user?.name ? formatName(user.name) : "—",
        empType: user?.empType ?? "—",
        designation: user?.designation ?? "—",
        employeeId: user?.id != null ? String(user.id) : "—",
        email: user?.email ?? "—",
        department: user?.department ?? user?.location ?? "—",
        manager: user?.managerName ? formatName(user.managerName) : "—",
        photoPath: user?.photoPath,
    };
}
